module.exports = __webpack_public_path__ + "img/icon_st06.517ac262.png";